// quickLink.js
var QuickLink = pc.createScript('quickLink');


// this script is interconnected with quicklinkscript 

// initialize code called once per entity
QuickLink.prototype.initialize = function() {
    this.entity.element.on('mouseenter', this.onEnter, this);
    this.entity.element.on('mouseleave', this.onLeave, this);
    this.entity.element.on('click', this.up, this);
    this.cam = this.app.root.findByName('Camera');
    this.thePosition = new pc.Vec3();
    this.camScript = this.cam.script.orbitCamera;
    this.planetType = null; // SET IN planetButtons.js
    this.order = 0;
    this.thePlanet = null;
    this.allbuttons = [];
    this.tweenIn = null;
    this.tweenOut = null;
    this.scl = this.entity.getLocalScale();

};

QuickLink.prototype.scaleIn = function(lp){
    this.entity.setLocalScale(0,0,0);
    this.entity.tween(this.entity.getLocalScale()).to({x:1, y:1, z:1}, 1.5, pc.ExponentialOut).delay(0.1 * lp).start();    
};

QuickLink.prototype.up = function(){
    this.setMinMax();
    this.camScript.resetAndLookAtPoint(this.cam.getLocalPosition(), this.thePosition);
    for(var bc = 0; bc < this.entity.parent.children.length; bc++){
        this.entity.parent.children[bc].children[1].enabled = false;
    }  
    var scl = new pc.Vec3(1,1,1);
    this.entity.tween(this.entity.getLocalScale()).to({x: 0.75, y: 0.75, z:0.75}, 0.1, pc.ExponentialOut).yoyo(true).repeat(2).start();
  //  console.log('btn: ' + this.thePlanet.name);
    this.app.fire('userInput:test', this.thePlanet);
    this.app.fire('userInput:objectSelected', this.thePlanet);
    this.app.fire('uiGenerator:stopPlanetSound');
};

QuickLink.prototype.onEnter = function(){
    if(this.tweenOut){
        this.tweenOut.stop();
    }
    var piScript = this.app.root.children[0].script.planetInfoGenerator;
    this.tweenIn = this.entity.tween(this.entity.getLocalScale()).to({x: 1.5, y: 1.5, z:1.5}, 0.75, pc.ElasticOut).on('complete', function(){
      this.entity.children[2].enabled = true;  
    }).start();
    var pi = null;
    if(piScript.plntInfo.length === 0){
        pi = piScript.systemName.substring(5, piScript.systemName.length);
    } else {
        pi = piScript.plntInfo[this.order].substring(5,piScript.plntInfo[this.order].length);
    }
    if(this.planetType == 'system'){
        pi = piScript.systemName.substring(5, piScript.systemName.length);
    }
    this.entity.children[2].element.text = pi; 
};

QuickLink.prototype.onLeave = function(){
    if(this.tweenIn){
        this.tweenIn.stop();
    }
    //this.entity.setLocalScale(1,1,1);
    this.entity.children[2].enabled = false;
    this.tweenOut = this.entity.tween(this.entity.getLocalScale()).to({x: 1, y: 1, z:1}, 2.5, pc.ElasticOut).start();
};


QuickLink.prototype.setMinMax = function(){
    if(this.planetType === 'system'){
       // console.log('QUICKLINK:PLANETMINMAX_S');
        this.camScript.distanceMin = 1000;
        this.camScript.distanceMax = 2500;
    } else if(this.planetType === 'rockPlanet'){
      //  console.log('QUICKLINK:PLANETMINMAX_R');
        this.camScript.distanceMin = 150;
        this.camScript.distanceMax = 200;
    } else if (this.planetType === 'gasGiant'){
       // console.log('QUICKLINK:PLANETMINMAX_G');
        this.camScript.distanceMin = 350;
        this.camScript.distanceMax = 600;
    } else if(this.planetType === 'habitable'){
     //   console.log('QUICKLINK:PLANETMINMAX_H');
        this.camScript.distanceMin = 150;
        this.camScript.distanceMax = 200;
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// QuickLink.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

